import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Activity, Clock, CheckCircle, AlertCircle } from 'lucide-react';
import { API_URL } from '../config/api';
import './Studies.css';

const Studies = () => {
    const [studies, setStudies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStudies();
    }, []);

    const fetchStudies = async () => {
        try {
            const response = await fetch(`${API_URL}/studies`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            if (response.ok) {
                const data = await response.json();
                setStudies(data);
            }
        } catch (error) {
            console.error('Error fetching studies:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'pending': return <span className="badge badge-warning">Pendiente</span>;
            case 'with_sample_1': return <span className="badge badge-info">Muestra 1 Recibida</span>;
            case 'sample_2_required': return <span className="badge badge-danger">Requiere 2da Muestra</span>;
            case 'completed': return <span className="badge badge-success">Completado</span>;
            default: return <span className="badge">{status}</span>;
        }
    };

    return (
        <div className="studies-container">
            <div className="studies-header">
                <h2><Activity /> Gestión de Estudios</h2>
                <Link to="/dashboard" className="btn btn-secondary">Volver al Panel</Link>
            </div>

            {loading ? (
                <p>Cargando estudios...</p>
            ) : (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Paciente</th>
                                <th>Estudio</th>
                                <th>Resultado Final</th>
                                <th>Estado</th>
                                <th>Fecha Creación</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studies.map(study => (
                                <tr key={study.id}>
                                    <td>#{study.id}</td>
                                    <td>{study.first_name} {study.last_name} {study.maternal_last_name || ''}</td>
                                    <td>{study.name}</td>
                                    <td>
                                        {study.final_result ? (
                                            <span className="font-medium">{study.final_result}</span>
                                        ) : (
                                            <span className="text-muted">-</span>
                                        )}
                                    </td>
                                    <td>{getStatusBadge(study.status)}</td>
                                    <td>{new Date(study.created_at).toLocaleDateString()}</td>
                                    <td>
                                        <Link to={`/studies/${study.id}`} className="btn btn-sm btn-primary">
                                            Ver Detalles
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                            {studies.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="text-center">No hay estudios registrados.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Studies;
